import { required, helpers } from '@vuelidate/validators';

export const cardValidation = {
  cardDetails: {
    cardNumber: {
      required: helpers.withMessage("Card number is required.", required),
      validLength: helpers.withMessage(
        "Please enter exactly 16 digits",
        value => {
          if (!value) return true;
          const digits = value.replace(/\D/g, '');
          return digits.length === 16;
        }
      ),
      maxLength: helpers.withMessage(
        "Maximum 16 digits allowed",
        value => {
          if (!value) return true;
          const digits = value.replace(/\D/g, '');
          return digits.length <= 16;
        }
      )
    },
    // expiry: {
    //   required: helpers.withMessage("Expiry date is required.", required),
    //   validFormat: helpers.withMessage(
    //     "Invalid format. Use MM/YY.",
    //     value => /^\d{2}\/\d{2}$/.test(value)
    //   ),
    //   futureDate: helpers.withMessage(
    //     "Expiry date must be in the future",
    //     value => {
    //       if (!/^\d{2}\/\d{2}$/.test(value)) return true;
    //       const [month, year] = value.split('/');
    //       const expiryDate = new Date(2000 + parseInt(year), parseInt(month) - 1);
    //       return expiryDate > new Date();
    //     }
    //   )
    // },
    // cvv: {
    //   required: helpers.withMessage("CVV is required.", required),
    //   validFormat: helpers.withMessage(
    //     "CVV must be 3 digits",
    //     value => /^\d{3}$/.test(value)
    //   )
    // },
    cardHolderName: {
      required: helpers.withMessage("Card holder name is required.", required)
    }
  },
   Amount: {
    required: helpers.withMessage("Amount is required.", required),
     numericOnly: helpers.withMessage(
          "Amount must be a valid number.",
          (value) => /^(\d+(\.\d{1,2})?)$/.test(value)
        ),
   
  }
};
